export default function Error({ error }) {
  const isMessage = error && error?.message;
  const message = isMessage ? (error.message?.errors ? error.message.errors[0] : error.message) : null;
  return (
    <div className="invalid-feedback d-block mt-0 mb-2">
      {message}
      <br />
    </div>
  );
}
